/**
 * Components: List.
 *
 * @since 3.11.0
 */

/**
 * External dependencies
 */
import styled from 'styled-components';

/**
 * @inheritDoc
 */
const List = styled.ul`
	margin: 0 auto;
	padding-bottom: 8px;
`;

// Finally export the `List` component.
export default List;
